import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from './DatasetCards';
import { ArrowUpRight, Lock } from 'lucide-react';

export default function NewsGrid({ items = [], limit, loading = false }) {
  const list = limit ? items.slice(0, limit) : items;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24">
      <SectionHeading
        kicker="In the news"
        title={<>The press <span className="italic font-light">on the public purse.</span></>}
        subtitle="A live noticeboard of Canadian coverage of government spending and integrity. Headlines are the publisher's words, not Spill the Hill."
        right={!limit ? null :
          <Link to="/news" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-copper-600 hover:text-copper-500 transition">
            All news →
          </Link>
        }
      />

      {loading && list.length === 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array.from({ length: limit || 6 }).map((_, i) => (
            <div key={i} className="bg-cream-50 border border-ink-300/60 rounded-sm p-7 animate-pulse">
              <div className="h-3 w-32 bg-ink-200 mb-5" />
              <div className="h-5 w-3/4 bg-ink-200 mb-2" />
              <div className="h-5 w-1/2 bg-ink-200" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {list.map((n, i) => (
            <a
              key={i}
              href={n.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-cream-50 border border-ink-300/60 rounded-sm p-7 lift block"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="flex items-center gap-2">
                  <span className="kicker text-copper-600">{n.outlet}</span>
                  {n.outlet_count && n.outlet_count > 1 && (
                    <span className="text-[10px] uppercase tracking-wider bg-copper-50 text-copper-600 px-2 py-0.5 rounded-full font-medium border border-copper-200">
                      {n.outlet_count} outlets
                    </span>
                  )}
                </div>
                <div className="text-[11px] text-ink-500 tabular">{n.hours_ago || 0}h ago</div>
              </div>
              <h3 className="font-serif text-[20px] leading-[1.3] text-ink-800 group-hover:text-copper-600 transition">
                {n.title}
              </h3>
              <div className="mt-6 pt-5 border-t border-ink-300/40 flex items-center justify-between text-[12px]">
                {n.paywall ? (
                  <span className="inline-flex items-center gap-1 text-ink-500 uppercase tracking-wider">
                    <Lock size={10} /> Paywall
                  </span>
                ) : (
                  <span className="text-sage-500 uppercase tracking-wider">Open access</span>
                )}
                <span className="inline-flex items-center gap-1 text-ink-700 group-hover:text-copper-600 transition">
                  Read at {n.outlet} <ArrowUpRight size={12} />
                </span>
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
}
